import React from "react";
import Lottie from "lottie-react";
import * as fileFolderLoading from "./file-folder.json";

function LottieFileFolder(props) {
  return (
    <Lottie
      animationData={fileFolderLoading.default}
      loop={true}
      autoplay={true}
      rendererSettings={{
        preserveAspectRatio: "xMidYMid slice",
      }}
      height={120}
      width={120}
    />
  );
}

export default LottieFileFolder;
